import { TextField, styled } from '@mui/material';

export const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-input': {
        ...theme.typography.caption1_Thin,
        color: theme.palette.background.default,
    },
    '& .MuiInputLabel-root': {
        ...theme.typography.caption1_Thin,
        color: theme.palette.grey[400],
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: theme.palette.grey[400],
    },
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.grey[600],
            borderWidth: '2px',
        },
        '&:hover fieldset': {
            borderColor: theme.palette.grey[600],
        },
    },
    '& textarea': {
        minHeight: '30px',
    },
    borderColor: theme.palette.grey[400],
    borderWidth: '1px',
    color: theme.palette.background.default,
    minWidth: '100%',
}));
